import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import { setInteractionsLockedData } from 'services/scorm/scormService';

// export default (id, showMessage = false) => {
//   if (!window.dev())
//     return requestAnimationFrame(() => {
//       const block = getBlockById(id);
//       if (block.props.lockDown === 0) return;
//       setBlockProps(getBlockById(id), { lockDown: 0 });
//     });
//   showMessage && console.log(`${id} will unlock in production. . .`);
// };

const unlockInteraction = (id, length = 0) => {
  if (window.dev()) return () => {};

  const block = getBlockById(id);
  const { lockDown } = block.props;

  if (!!!length) {
    if (lockDown === 1) {
      setInteractionsLockedData(id);
      setBlockProps(block, { lockDown: 0 });
    }
    // lockDown === 1 && setBlockProps(block, { lockDown: 0 });
    return () => {};
  }

  let itemsSeen = [];

  return entry => {
    if (block.props.lockDown === 0) return;

    itemsSeen = itemsSeen.includes(entry) ? itemsSeen : [...itemsSeen, entry];
    itemsSeen.length === length &&
      requestAnimationFrame(() => {
        setInteractionsLockedData(id);
        setBlockProps(block, { lockDown: 0 });
      });

    return itemsSeen;
  };
};

export default unlockInteraction;
export { unlockInteraction };
